import React from "react";
import { ArrowRight, Info, Loader2, Save, X } from "lucide-react";

import { Button } from "@/components/ui";

import { CategoryPath } from "../CategoryPath";
import { ConfidenceBadge } from "../ConfidenceBadge";
import type { SaveBarProps } from "./SaveBar.types";

export const SaveBar: React.FC<SaveBarProps> = ({
  selectedProductType,
  selectedCategory,
  isPending,
  onClear,
  onConfirm,
}) => (
  <div className="flex items-start justify-between gap-4 p-4 rounded-lg bg-gradient-to-r from-indigo-50 to-slate-50 dark:from-indigo-950/30 dark:to-slate-800/30 border border-indigo-200 dark:border-indigo-800">
    <div className="flex-1 min-w-0 space-y-2">
      <div className="flex items-center gap-3 min-w-0">
        <div className="flex flex-col min-w-0">
          <span className="text-[10px] uppercase tracking-wider text-slate-400 dark:text-slate-500">
            Marketplace Product Type
          </span>
          <span className="text-sm font-semibold text-slate-900 dark:text-slate-100 truncate">
            {selectedProductType.displayName || selectedProductType.name}
          </span>
          <span className="text-[10px] font-mono text-slate-400 dark:text-slate-500">
            {selectedProductType.name}
          </span>
        </div>
        <ArrowRight className="w-4 h-4 text-indigo-400 shrink-0" />
        <div className="flex flex-col min-w-0 flex-1">
          <span className="text-[10px] uppercase tracking-wider text-slate-400 dark:text-slate-500">
            Canonical Category
          </span>
          <CategoryPath path={selectedCategory.path} size="sm" />
          <ConfidenceBadge confidence={selectedCategory.confidence} />
        </div>
        <Button
          variant="ghost"
          size="sm"
          className="h-6 text-[10px] shrink-0"
          onClick={onClear}
        >
          <X className="w-3 h-3" /> Change
        </Button>
      </div>

      <div className="flex items-start gap-1.5 text-[11px] leading-4 text-slate-500 dark:text-slate-400">
        <Info className="w-3.5 h-3.5 mt-0.5 shrink-0 text-indigo-500" />
        <span>
          Saves this product-type category mapping for future syncs. Attribute
          mapping improves later when reviewed field mappings are approved.
        </span>
      </div>
    </div>

    <Button
      data-testid="save-canonical-mapping-btn"
      onClick={onConfirm}
      disabled={isPending}
      className="shrink-0 mt-0.5"
    >
      {isPending ? (
        <>
          <Loader2 className="w-4 h-4 animate-spin" /> Saving & Syncing...
        </>
      ) : (
        <>
          <Save className="w-4 h-4" /> Save Mapping &amp; Start Sync
        </>
      )}
    </Button>
  </div>
);
